import createAction from 'redux-actions/lib/createAction';

export const SET_RESULT_CODE = 'shopCheckoutActions/SET_RESULT_CODE';
export const setResultCode = createAction(SET_RESULT_CODE);
